import { axiosInstance } from "contexts/axiosApiInstance";
import { createLogger } from "debug/DebugingLogger";

const log = createLogger("SharedWithMeApi");

/// Mirrors the server `SharedSpaceResponse` (organizations/spaces.rs): a space
/// the caller holds a direct grant on, inside an org they are NOT a member of
/// (D32). Identity-scoped — the same answer whichever org context is active.
export interface SharedSpace {
  space_id: string;
  name: string;
  /// Palette short-name (`"sky"`), empty = derive from the id.
  color: string;
  sealed: boolean;
  /// The caller's strongest granted relation: "manager" | "collaborator" |
  /// "viewer".
  role: string;
  org_id: string;
  /// The owning org's display label — its owner's identity when the org is
  /// personal (every personal org is literally named "Personal"), the org's
  /// name otherwise.
  org_label: string;
  org_is_personal: boolean;
  granted_by_name?: string;
  granted_by_email?: string;
  model_count: number;
}

/// `null` means "we could not find out", which is NOT the same as an empty
/// list: collapsing the two would let a transient 500 hide the nav item and
/// tell the user, definitively, that nothing is shared with them.
export async function fetchSharedWithMeSpaces(): Promise<SharedSpace[] | null> {
  try {
    const response = await axiosInstance.get<SharedSpace[]>(
      "/action/spaces/shared_with_me",
    );
    return response.data;
  } catch (error) {
    log.error("fetchSharedWithMeSpaces failed", error);
    return null;
  }
}
